'use client';

import classNames from 'classnames';

import { ArticleCardSmall } from '~components/ArticleCardSmall/ArticleCardSmall';
import { Section } from '~components/Section/Section';
import { HeaderSection } from '~containers/MainPage/HeaderSection/HeaderSection';

import styles from './SectionNews.module.scss';
import { SectionNewsProps } from './SectionNews.types';

const ARTICLES_COUNT = 4;

export function SectionNews({
  title,
  titleBacklight,
  articles,
  category,
  ...sectionProps
}: SectionNewsProps) {
  if (!articles.length) return null;

  const featuredArticles = articles.slice(0, ARTICLES_COUNT);

  return (
    <Section className={classNames(styles.section)} {...sectionProps}>
      {title && (
        <HeaderSection
          title={title}
          titleBacklight={titleBacklight}
          href={category.href}
          countArticles={category.count}
          hasPageCategory={!!category.pageCategoryId}
        />
      )}
      <div className={classNames(styles.articles)}>
        {featuredArticles.map((article) => (
          <ArticleCardSmall
            key={article.id}
            className={styles.article}
            {...article}
          />
        ))}
      </div>
    </Section>
  );
}
